var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Presentation'),_c('Evaluation'),_c('BlackBox',{attrs:{"customText":"show","text":_vm.$t('BlackBox.bio')}}),_c('BGuide'),_c('SGuide'),_c('Testimonial'),_c('Information')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }